import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { EfaactDataService } from '../../efaact.data-service';
import { RecalculateSchedule } from './recalculate-schedules.model';

export const entityName = 'ProcessingSchedule';

@Injectable()
export class RecalculateSchedulesDataService extends EfaactDataService<RecalculateSchedule> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
        this.usePostForQuery = true;
    }

    mapItems(item: RecalculateSchedule): RecalculateSchedule {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.ProcessScheduleID,
            PeriodStartDate: moment(item.PeriodStartDate).isValid()
                ? moment(item.PeriodStartDate).toDate()
                : null,
            PeriodEndDate: moment(item.PeriodEndDate).isValid()
                ? moment(item.PeriodEndDate).toDate()
                : null,
            QBImportDate: moment(item.QBImportDate).isValid()
                ? moment(item.QBImportDate).toDate()
                : null,
            EFCommitDate: moment(item.EFCommitDate).isValid()
                ? moment(item.EFCommitDate).toDate()
                : null
        };
    }
}
